<template>
  <div :style="style">
    <div class="lo" ref="pr"></div>
  </div>
</template>

<script>
import lottie from "lottie-web";
import * as animationData from "@/assets/loader-cargo.json";

export default {
  props: {
    options: {
      type: Object,
      required: true,
    },
    height: Number,
    width: Number,
    defaultSpeed: Number,
  },

  data() {
    return {
      style: {
        display: "flex",
        "justify-content": "center",
        "align-items": "center",
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        margin: "0 auto",
        "background-color": "#FF1744",
        "z-index": "9999",
      },
    };
  },

  mounted() {
    this.anim = lottie.loadAnimation({
      container: this.$refs.pr,
      renderer: "svg",
      loop: false,
      autoplay: this.options.autoplay !== false,
      animationData: animationData.default,
      name: this.options.animationName !== "default",
      rendererSettings: this.options.rendererSettings,
    });
    this.$emit("animCreated", this.anim);
    this.anim.addEventListener("complete", (e) => {
      this.$emit("animComplete", this.anim);
    });

    this.anim.addEventListener("segmentStart", (e) => {
      this.$emit("animSegmentStart", this.anim);
    });
    this.anim.addEventListener("config_ready", (e) => {
      // when initial config is done
      this.$emit("animConfigReady", this.anim);
    });
    this.anim.addEventListener("data_ready", (e) => {
      // when all parts of the animation have been loaded
      this.$emit("animDataReady", this.anim);
    });
    this.anim.addEventListener("data_failed", (e) => {
      // when part of the animation can not be loaded
      this.$emit("animDataFailed", this.anim);
    });
    this.anim.addEventListener("loaded_images", (e) => {
      // when all image loads have either succeeded or errored
      this.$emit("animLoadedImages", this.anim);
    });
    this.anim.addEventListener("DOMLoaded", (e) => {
      // when elements have been added to the DOM
      this.$emit("animDOMLoaded", this.anim);
    });
    this.anim.addEventListener("destroy", (e) => {
      // when lottie.destroy() is called to destroy and release resources. The DOM element will be emptied
      this.$emit("animDestroy", this.anim);
    });
  },
  destroyed() {
    this.anim.removeEventListener("loopComplete");
    this.anim.removeEventListener("complete");
    this.anim.removeEventListener("enterFrame");
    this.anim.removeEventListener("segmentStart");
    this.anim.removeEventListener("config_ready");
    this.anim.removeEventListener("data_ready");
    this.anim.removeEventListener("data_failed");
    this.anim.removeEventListener("loaded_images");
    this.anim.removeEventListener("DOMLoaded");
    this.anim.removeEventListener("destroy");
  },
};
</script>

<style>
.lo {
  width: 22vw;
  height: 22vw;
}

@media screen and (max-width: 992px) {
  .lo {
    width: 100vw !important;
    height: 80vw;
  }
}

@media (orientation: landscape) {
  .lo {
    width: 40vw !important;
    /* height: 80vw; */
  }
}
</style>